(() => {
  function initSectionAnimation(section) {
    if (!section || section.dataset.mapOverlayInit === 'true') {
      return;
    }

    const lines = section.querySelectorAll('.map-overlay-2026__overlay-line');
    if (!lines.length) {
      return;
    }

    const reveal = () => {
      const mapWrap = section.querySelector('.map-overlay-2026__map-wrap');
      const overlay = section.querySelector('.map-overlay-2026__overlay');
      
      // Reset animation state
      if (mapWrap) {
        mapWrap.classList.remove('is-visible');
      }
      if (overlay) {
        overlay.classList.remove('is-visible');
      }
      lines.forEach((line) => {
        line.classList.remove('is-visible');
      });
      
      // Trigger reflow to restart animation
      void section.offsetHeight;
      
      // Reveal map first
      if (mapWrap) {
        mapWrap.classList.add('is-visible');
      }
      
      // Reveal overlay text layer after map
      setTimeout(() => {
        if (overlay) {
          overlay.classList.add('is-visible');
        }
        // Then reveal individual lines
        lines.forEach((line, index) => {
          setTimeout(() => {
            line.classList.add('is-visible');
          }, index * 140);
        });
      }, 200);
    };

    section.classList.add('map-overlay-2026--anim-ready');
    section.dataset.mapOverlayInit = 'true';

    if ('IntersectionObserver' in window) {
      const observerTarget = section.querySelector('.map-overlay-2026__map-wrap') || section;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal();
          }
        });
      }, { threshold: 0.2 });

      observer.observe(observerTarget);
    } else {
      reveal();
    }
  }

  function initAllSections() {
    document.querySelectorAll('.map-overlay-2026').forEach((section) => {
      initSectionAnimation(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections, { once: true });
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.classList && event.target.classList.contains('map-overlay-2026')) {
      initSectionAnimation(event.target);
      return;
    }

    if (event.target && event.target.querySelector) {
      const nestedSection = event.target.querySelector('.map-overlay-2026');
      if (nestedSection) {
        initSectionAnimation(nestedSection);
      }
    }
  });
})();
